import { Card, FormItem, TextInput } from '@ingrid/luterkort-react';

import { ValidationError } from '~src/components/ValidationError/ValidationError';
import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractFormContext } from '../types';
import { Validate } from './validate';

export function BasicInfo() {
  const { formState, register } = useCarrierContractFormContext();
  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.basicInformation')}</Card.Header>

      <Card.Content>
        <Card.List>
          <FormItem.Root>
            <FormItem.Label>{t('common.name')}</FormItem.Label>
            <FormItem.Control invalid={!!formState.errors.name?.message}>
              <TextInput {...register('name', Validate().name)} aria-required="true" />
            </FormItem.Control>

            <ValidationError errors={formState.errors} name="name" />
          </FormItem.Root>

          <FormItem.Root>
            <FormItem.Label>{`${t('common.description')} (${t('common.optional')})`}</FormItem.Label>
            <FormItem.Control invalid={!!formState.errors.description?.message}>
              <TextInput {...register('description', Validate().description)} aria-required="true" />
            </FormItem.Control>

            <ValidationError errors={formState.errors} name="description" />
          </FormItem.Root>
        </Card.List>
      </Card.Content>
    </Card.Wrapper>
  );
}
